import groupOptionsByOptGroup from '../../utils/optGroup/optGroup';

/** @type {ReadonlySet<string>} */
const ROW_ACTION_TYPES = new Set([
  'openTab',
  'openFormModal',
  'reloadTable',
  'deleteLine',
  'openSubActions',
]);

/**
 * @param {ApiManagerTableActionsArray | null | undefined} actions
 * @returns {boolean}
 */
export function hasRowActions(actions) {
  return (actions ?? []).some((actionItem) => Object.values(actionItem).some((action) => action !== null));
}

/**
 * @param {ApiManagerTableActionsArray | null | undefined} actions
 * @param {string} keyPrefix
 * @returns {TableRowActionFlattened[]}
 */
export function flattenRowActions(actions, keyPrefix) {
  if (!actions?.length) return [];

  /** @type {TableRowActionFlattened[]} */
  const flattened = [];

  actions.forEach((actionItem, itemIndex) => {
    Object.entries(actionItem).forEach(([type, action]) => {
      if (action === null || !ROW_ACTION_TYPES.has(type)) return;
      flattened.push({
        ...action,
        type,
        id: `${keyPrefix}-${itemIndex}-${type}`,
      });
    });
  });

  return flattened;
}

/**
 * First-level actions marked as quick actions (nested items inside openSubActions are ignored).
 * @param {ApiManagerTableActionsArray | null | undefined} actions
 * @param {string} rowId
 * @returns {TableRowActionFlattened[]}
 */
export function getQuickRowActions(actions, rowId) {
  return flattenRowActions(actions, rowId).filter((action) => action.isQuickAction === true);
}

/**
 * @param {TableRowActionFlattened[]} flattened
 * @returns {Array<{ lib: string, options: TableRowActionFlattened[] }>}
 */
export function groupRowActions(flattened) {
  return groupOptionsByOptGroup(flattened);
}
